export type AppMode = 'live' | 'test';

const STORAGE_KEYS = {
    appMode: 'honestart.appMode',
} as const;

const safeGetItem = (key: string): string => {
    try {
        return localStorage.getItem(key) || '';
    } catch {
        return '';
    }
};

const safeSetItem = (key: string, value: string) => {
    try {
        localStorage.setItem(key, value);
    } catch {
        // ignore (e.g. storage disabled)
    }
};

export function getAppMode(): AppMode {
    const raw = safeGetItem(STORAGE_KEYS.appMode);
    // Default to test unless explicitly set to live
    return raw === 'live' ? 'live' : 'test';
}

export function setAppMode(mode: AppMode) {
    safeSetItem(STORAGE_KEYS.appMode, mode);
}

